module.exports = __webpack_public_path__ + "img/status-error.caf573d2.svg";